export default "__VITE_ASSET__B$XjomYU__"